import React from "react";
import { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { columnLabel } from "../Functionalities/reportColumns";

export default function ColumnModalComponentX({ columns, heading, selectedColumns, Push, Pop, clearSelectedColumns, applySelectedColumns, setOrder, reset }) {



  // const getItems = count =>
  // Array.from({ length: count }, (v, k) => k).map(k => ({
  //   id: `item-${k}`,
  //   // content: `item ${k}`
  // }));
  // void 0
  const [Items, setItems] = useState(columns)

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const grid = 8;

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    color: "black",
    border: '1px solid ',
    borderRadius: '.5rem',
    background: "white",
    borderColor: isDragging ? "#FB310D" : "lightgray",
    // change background colour if dragging
    // background: isDragging ? "lightgreen" : "grey",

    // styles we need to apply on draggables
    ...draggableStyle
  });

  const getListStyle = isDraggingOver => ({
    // background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: grid,
    // width: 250
  });

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const newItems = reorder(
      Items,
      result.source.index,
      result.destination.index
    );
    setItems(newItems);
    localStorage.setItem('foodoor_table_heading_order', JSON.stringify(newItems))
    setOrder(newItems)
  }
  // const tableData = window.localStorage.getItem('table_heading_order')
  // const convertedData = tableData.split(',')
  // void 0




  return (
    <div className="modal fade" id="ColumnModal">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{heading}</h5>
            <button type="button" className="close" data-dismiss="modal" >
              <span>×</span>
            </button>
          </div>

          <div className="modal-body">
            <form className="comment-form">
            <div className="col-lg-12">
                <div className="form-group mb-0 text-center">
                  <button
                    style={{ marginRight: 10 }}
                    data-dismiss="modal"
                    className="submit btn btn-primary"
                    name="submit"
                    onClick={clearSelectedColumns}
                  >
                    Clear
                  </button>
                  <button
                    style={{ marginRight: 10 }}
                    data-dismiss="modal"
                    type="submit"
                    id="tests"
                    className="submit btn btn-primary"
                    name="submit"
                    onClick={applySelectedColumns}
                  >
                    Apply
                  </button>
                  <button
                    style={{ marginRight: 10 }}
                    data-dismiss="modal"
                    type="submit"
                    id="tests"
                    className="submit btn btn-primary"
                    name="submit"
                    onClick={reset}
                  >
                    Reset Columns
                  </button>
                  {/* <input
                          type="submit"
                          data-dismiss={"modal"}
                          className="submit btn btn-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            getData();
                          }}
                          name="Apply Filter"
                        /> */}
                </div>
              </div>
              <div className="row justify-content-center">

                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                      >
                        {Items.map((item, index) => {
                          // void 0
                          return (

                            <div className="col-lg-12">
                              

                              {item === "id" &&
                                <div
                                  className="form-group"
                                  style={{ padding: '16px', margin: '0 0 8px', border: '1px solid #dedede', borderRadius: '.5rem' }}
                                >
                                  <label className="text-black font-w600">

                                    <input
                                      type="checkbox"
                                      disabled={item === "id" ? true : false}
                                      checked={!selectedColumns.includes(item)}
                                      // value={selectedColumns.includes(item)}
                                      onChange={(e) => selectedColumns.includes(item) ? Pop(item) : Push(item)}
                                    />&nbsp;{" : "}{columnLabel(item)}
                                  </label>
                                  {/* {item.content} */}
                                </div>

                              }
                              {item !== "id" &&

                                <Draggable key={JSON.stringify(index)} draggableId={JSON.stringify(index)} index={index}>
                                  {(provided, snapshot) => (
                                    <div
                                      className="form-group"
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={getItemStyle(
                                        snapshot.isDragging,
                                        provided.draggableProps.style
                                      )}
                                    >
                                      <label className="text-black font-w600">

                                        <input
                                          type="checkbox"
                                          disabled={item === "id" ? true : false}
                                          checked={!selectedColumns.includes(item)}
                                          // value={selectedColumns.includes(item)}
                                          onChange={(e) => selectedColumns.includes(item) ? Pop(item) : Push(item)}
                                        />&nbsp;{" : "}{columnLabel(item)}
                                      </label>
                                      {/* {item.content} */}
                                    </div>
                                  )}
                                </Draggable>
                              }
                            </div>
                          )
                        })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>


              <div className="col-lg-12">
                <div className="form-group mb-0 text-center">
                  <button
                    style={{ marginRight: 10 }}
                    data-dismiss="modal"
                    className="submit btn btn-primary"
                    name="submit"
                    onClick={clearSelectedColumns}
                  >
                    Clear
                  </button>
                  <button
                    style={{ marginRight: 10 }}
                    data-dismiss="modal"
                    type="submit"
                    id="tests"
                    className="submit btn btn-primary"
                    name="submit"
                    onClick={applySelectedColumns}
                  >
                    Apply
                  </button>
                  <button
                    style={{ marginRight: 10 }}
                    data-dismiss="modal"
                    type="submit"
                    id="tests"
                    className="submit btn btn-primary"
                    name="submit"
                    onClick={reset}
                  >
                    Reset Columns
                  </button>
                  {/* <input
                          type="submit"
                          data-dismiss={"modal"}
                          className="submit btn btn-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            getData();
                          }}
                          name="Apply Filter"
                        /> */}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

